import { LoaderCircle, Plus, Shuffle, Sparkles, Trash2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";

export const VariantsEditor = ({ form, setForm }) => {
  const [generating, setGenerating] = useState(false);
  const variants = form.variants || [];

  const update = (index, changes) => {
    setForm((current) => ({ ...current, variants: current.variants.map((variant, i) => (i === index ? { ...variant, ...changes } : variant)) }));
  };

  const remove = (index) => setForm((current) => ({ ...current, variants: current.variants.filter((_, i) => i !== index) }));

  const add = () => setForm((current) => ({ ...current, variants: [...(current.variants || []), { email_subject: "", email_body: "" }] }));

  const generate = async () => {
    if (!form.email_body.trim()) return toast.error("Rédigez d’abord le texte principal de l’e-mail.");
    setGenerating(true);
    try {
      const instruction = `Réécris cet e-mail en gardant EXACTEMENT le même sens, les mêmes informations et les mêmes variables entre accolades, mais avec une formulation et un objet différents pour éviter les envois identiques :\n\nOBJET : ${form.email_subject}\n\n${form.email_body}`;
      const { data } = await api.post("/ai/email-draft", { instruction, context: "automation" }, { timeout: 120000 });
      const fresh = (data.variants || []).slice(0, 2).map((variant) => ({ email_subject: variant.subject, email_body: variant.body }));
      setForm((current) => ({ ...current, variants: fresh }));
      toast.success(`${fresh.length} variantes générées — relisez-les avant d’enregistrer.`);
    } catch (error) {
      toast.error(error.response?.data?.detail || "La génération des variantes a échoué.");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="variants-editor" data-testid="variants-editor">
      <div className="variants-head">
        <div>
          <p className="field-label"><Shuffle size={14} /> Variantes anti-spam ({variants.length})</p>
          <p className="field-help">Les envois alternent automatiquement entre le texte principal et ces variantes, pour éviter 1 500 e-mails strictement identiques.</p>
        </div>
        <div className="button-row">
          <button type="button" className="secondary-button" onClick={generate} disabled={generating} data-testid="variants-generate-button">
            {generating ? <LoaderCircle size={14} className="spinning" /> : <Sparkles size={14} />}{generating ? "Génération…" : "Générer 2 variantes avec l’IA"}
          </button>
          <button type="button" className="secondary-button" onClick={add} disabled={variants.length >= 4} data-testid="variants-add-button">
            <Plus size={14} /> Ajouter
          </button>
        </div>
      </div>
      {variants.map((variant, index) => (
        <div key={index} className="variant-card" data-testid={`variant-card-${index}`}>
          <div className="variant-card-head">
            <strong>Variante {index + 1}</strong>
            <button type="button" className="icon-action danger-icon" onClick={() => remove(index)} aria-label="Supprimer la variante" data-testid={`variant-remove-${index}`}><Trash2 size={14} /></button>
          </div>
          <input value={variant.email_subject} placeholder="Objet (vide = objet principal)" onChange={(event) => update(index, { email_subject: event.target.value })} data-testid={`variant-subject-${index}`} />
          <textarea rows={6} value={variant.email_body} placeholder="Corps de la variante" onChange={(event) => update(index, { email_body: event.target.value })} data-testid={`variant-body-${index}`} />
        </div>
      ))}
    </div>
  );
};
